import { useCalCom } from '@/hooks/useCalCom'
import type { ReactNode } from 'react'

type CalDotComWrapperProps = {
	readonly children: ReactNode
}

// Component used to initialize the Cal.com embed API
export function CalDotComWrapper({ children }: CalDotComWrapperProps): ReactNode {
	useCalCom({
		namespace: 'bytebeam-101',
		layout: 'month_view',
	})

	return <div>{children}</div>
}
